
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import {deepCopy} from "@/auxillary";
import {ntdInstitutesModule, studyInstitutesModule} from "@/store";
import {rules} from "@/auxillary/rules";
import INtdInstituteCreateDto = MdbsCore.INtdInstituteCreateDto;
import NtdInstituteCreateDto = MdbsCore.NtdInstituteCreateDto;
import StudyInstituteShortDto = MdbsCore.StudyInstituteShortDto;
import INtdInstituteShortDto = MdbsCore.INtdInstituteShortDto;

@Component({})
export default class NtdInstituteCreateDialog extends Vue {
  @Prop({required: true})
  ntdInstitute!: INtdInstituteCreateDto;

  @Prop({required: true})
  allNtdInstitutes!: INtdInstituteShortDto[];

  currentInstitute: INtdInstituteCreateDto = new NtdInstituteCreateDto();
  saving = false;
  valid: boolean = false;
  rules: any = rules;

  get allStudyInstitutes() {
    let studyInstitutes =  studyInstitutesModule.studyInstitutes;
    return studyInstitutes.filter(o => !this.allNtdInstitutes.some(p => p.studyInstituteId == o.id));
  }

  get studyInstitutesLoadingLoading() {
    return studyInstitutesModule.isLoading;
  }

  getStudyInstituteName(studyInstitute: StudyInstituteShortDto) {
    return studyInstitute.identifier + " - " + studyInstitute.displayName
  }

  @Watch('institute', {immediate: true})
  async onInstituteChange(institute: INtdInstituteCreateDto | null) {
    if (institute == null) {
      return;
    }

    this.currentInstitute = deepCopy(institute);
    Vue.nextTick(() => {
      this.form.validate();
    });
    await studyInstitutesModule.loadAll();
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean }
  }

  async save() {
    try {
      this.saving = true;

      await ntdInstitutesModule.createNtdInstitute(this.currentInstitute);

      this.$emit('save');
    } finally {
      this.saving = false;
    }
  }

  async cancel() {
    this.$emit('cancel');
  }
}
